import { memo } from 'react'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import BackIcon from 'assets/svgr-icons/ArrowLeft.svg'
import * as Styled from './styled'

interface IProps {
  onBack: () => void
}

const SlideUpHeaderBackButton: React.FC<IProps> = ({ onBack }) => (
  <Styled.Header>
    <Styled.BackButton onClick={onBack}>
      <BackIcon />
      {translate(T.BACK)}
    </Styled.BackButton>
  </Styled.Header>
)

export default memo(SlideUpHeaderBackButton)
